module.exports = __webpack_public_path__ + "media/images/lb/865-1109f45883c2cb45af8f7a1382cfc602.svg";